(() => {
  'use strict';

  const lang = document.documentElement.lang.startsWith('lt') ? 'lt' : 'en';
  const dictionaries = window.SM_TRANSLATIONS || {};
  const text = key => dictionaries[lang]?.[key] || dictionaries.en?.[key] || key;
  const objectUrls = new Set();
  const ns = 'http://www.w3.org/2000/svg';

  document.querySelectorAll('[data-menu-toggle]').forEach(button => {
    const nav = document.getElementById(button.getAttribute('aria-controls'));
    if (!nav) return;
    button.addEventListener('click', () => {
      nav.hidden = !nav.hidden;
      button.setAttribute('aria-expanded', String(!nav.hidden));
    });
    nav.querySelectorAll('a').forEach(link => link.addEventListener('click', () => {
      nav.hidden = true;
      button.setAttribute('aria-expanded', 'false');
    }));
  });

  document.addEventListener('click', event => {
    document.querySelectorAll('.language-picker[open]').forEach(picker => {
      if (!picker.contains(event.target)) picker.removeAttribute('open');
    });
  });

  document.querySelectorAll('[data-board-pins]').forEach(group => {
    for (let i = 0; i < 200; i++) {
      const angle = i * Math.PI / 100;
      const pin = document.createElementNS(ns, 'circle');
      pin.setAttribute('cx', String(220 + 180 * Math.sin(angle)));
      pin.setAttribute('cy', String(220 - 180 * Math.cos(angle)));
      pin.setAttribute('r', '1.8');
      pin.setAttribute('fill', '#7b8070');
      group.append(pin);
    }
  });
  document.querySelectorAll('[data-board-lines]').forEach(group => {
    for (let i = 0; i < 200; i += 2) {
      const a = i * Math.PI / 100;
      const b = ((i * 3 + 74) % 200) * Math.PI / 100;
      const line = document.createElementNS(ns, 'line');
      line.setAttribute('x1', String(220 + 180 * Math.sin(a)));
      line.setAttribute('y1', String(220 - 180 * Math.cos(a)));
      line.setAttribute('x2', String(220 + 180 * Math.sin(b)));
      line.setAttribute('y2', String(220 - 180 * Math.cos(b)));
      line.setAttribute('stroke', '#556440');
      line.setAttribute('stroke-width', '.65');
      line.setAttribute('opacity', '.35');
      group.append(line);
    }
  });

  function photoValid(file) {
    return !!file && file.size > 0 && file.size <= 10 * 1024 * 1024 &&
      ['image/jpeg', 'image/png', 'image/webp'].includes(file.type);
  }

  function releasePreview(thumb) {
    if (!thumb) return;
    if (thumb.dataset.objectUrl) {
      URL.revokeObjectURL(thumb.dataset.objectUrl);
      objectUrls.delete(thumb.dataset.objectUrl);
      delete thumb.dataset.objectUrl;
    }
    thumb.hidden = true;
    thumb.removeAttribute('src');
  }

  document.querySelectorAll('[data-photo-form]').forEach(form => {
    const inputs = [...form.querySelectorAll('input[type="file"]')];
    const error = form.querySelector('[data-photo-error]');
    inputs.forEach(input => input.addEventListener('change', () => {
      const thumb = form.querySelector(`[data-file-preview="${input.dataset.photoIndex}"]`);
      releasePreview(thumb);
      const file = input.files[0];
      const invalid = !!file && !photoValid(file);
      input.setCustomValidity(invalid ? text('upload_error') : '');
      if (error) error.textContent = invalid ? text('upload_error') : '';
      if (thumb && photoValid(file)) {
        const url = URL.createObjectURL(file);
        objectUrls.add(url);
        thumb.dataset.objectUrl = url;
        thumb.src = url;
        thumb.hidden = false;
      }
    }));
    form.addEventListener('submit', event => {
      const valid = inputs.every(input => input.matches(':disabled') || (input.files.length ? photoValid(input.files[0]) : !input.required)) &&
        !!form.querySelector('[data-photo-consent]')?.checked;
      if (error) error.textContent = valid ? '' : text('upload_error');
      if (!valid) {
        event.preventDefault();
        form.reportValidity();
      }
      // A valid form submits directly to Shopify with its photo files attached.
    });
    form.addEventListener('reset', () => {
      inputs.forEach(input => input.setCustomValidity(''));
      form.querySelectorAll('[data-file-preview]').forEach(releasePreview);
      if (error) error.textContent = '';
    });
  });

  document.querySelectorAll('[data-country-select]').forEach(select => {
    select.addEventListener('change', () => select.form.requestSubmit());
  });
  window.addEventListener('pagehide', () => objectUrls.forEach(url => URL.revokeObjectURL(url)));
})();















/* String Memories design enhancements */
(() => {
  'use strict';
  let occasion = 'love';
  const translate = key => {
    const lang = document.documentElement.lang.startsWith('lt') ? 'lt' : 'en';
    return window.SM_TRANSLATIONS?.[lang]?.[key] || window.SM_TRANSLATIONS?.en?.[key] || '';
  };
  function updateOccasion() {
    document.querySelectorAll('[data-occasion]').forEach(button => {
      const active = button.dataset.occasion === occasion;
      button.classList.toggle('active', active);
      button.setAttribute('aria-pressed', String(active));
    });
    const message = document.querySelector('[data-occasion-message]');
    if (message) message.textContent = translate(`occasion_${occasion}_body`);
  }
  document.addEventListener('click', event => {
    const pill = event.target.closest('[data-occasion]');
    if (pill) { occasion = pill.dataset.occasion; updateOccasion(); }
    if (event.target.closest('[data-set-language]')) queueMicrotask(updateOccasion);
    const personalizeLink = event.target.closest('a[href="#personalize"]');
    if (personalizeLink) { const panel = document.getElementById('personalize'); if (panel) panel.open = true; }
    const thumbnail = event.target.closest('[data-product-image]');
    if (thumbnail) {
      const main = document.querySelector('.product-main-image');
      if (!main) return;
      main.src = thumbnail.dataset.productImage;
      main.removeAttribute('srcset');
      main.alt = thumbnail.querySelector('img')?.alt || '';
      document.querySelectorAll('[data-product-image]').forEach(button => button.setAttribute('aria-pressed', String(button === thumbnail)));
    }
  });
  const purchaseBar = document.querySelector('[data-sticky-purchase]');
  const productInfo = document.querySelector('.product-info');
  if (purchaseBar && productInfo && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver(entries => { purchaseBar.hidden = entries[0].isIntersecting; }, { threshold: 0 });
    observer.observe(productInfo);
  }
})();

